import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BANK_SELECTOR_OPTIONS } from '../../withdrawal-bank.config';

@Component({
  selector: 'app-withdrawal-bank-selector',
  templateUrl: './withdrawal-bank-selector.component.html',
})
export class WithdrawalBankSelectorComponent {
  @Input({ required: true }) form!: FormGroup;

  readonly bankOptions = BANK_SELECTOR_OPTIONS;
}
